import { render } from "./EconomicForm.vue?vue&type=template&id=591c9f6b&scoped=true"
import script from "./EconomicForm.vue?vue&type=script&lang=js"
export * from "./EconomicForm.vue?vue&type=script&lang=js"

import "./EconomicForm.vue?vue&type=style&index=0&id=591c9f6b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591c9f6b"]])

export default __exports__